// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1486":"10604813acd69cf4","5343":"6bae5b138473c0f7","8930":"f7c1359053467eb4"}[chunkId] + ".css";
};